module.exports = __webpack_public_path__ + "media/Chapter2VoiceOver.157f596f.mp3";